<script lang="ts">
  import { ChevronDown, ExternalLink } from "@lucide/svelte";
  import * as Tooltip from "../ui/tooltip/index.ts";
  import { valueParts } from "../../lib/osm/tags.ts";
  import { osmWikiKeyHref, osmWikiTagHref } from "../../lib/osm/wiki.ts";

  let {
    entries,
    osmHref,
  }: {
    entries: Array<[string, string]>;
    osmHref: string | undefined;
  } = $props();
</script>

{#snippet wikiLink(label: string, href: string, tooltip: string)}
  <Tooltip.Root>
    <Tooltip.Trigger>
      {#snippet child({ props })}
        <a
          {...props}
          class="rounded-sm underline decoration-muted-foreground/50 underline-offset-2 hover:decoration-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          {href}
          target="_blank"
          rel="noopener noreferrer"
        >
          {label}
        </a>
      {/snippet}
    </Tooltip.Trigger>
    <Tooltip.Content>{tooltip}</Tooltip.Content>
  </Tooltip.Root>
{/snippet}

<details class="group mt-5 border-t border-border pt-4 text-sm">
  <summary
    class="flex cursor-pointer list-none select-none items-center justify-between gap-3 px-4 text-xs font-semibold uppercase text-muted-foreground hover:text-foreground [&::-webkit-details-marker]:hidden"
  >
    <span>OpenStreetMap data ({entries.length})</span>
    <ChevronDown
      class="size-3.5 shrink-0 transition-transform group-open:rotate-180"
    />
  </summary>

  <div class="px-4">
    <table class="mt-3 w-full border-collapse font-mono text-[11px]">
      <tbody>
        {#each entries as [key, value]}
          <tr>
            <td
              class="border-b border-border px-1 py-1 align-top pr-3 whitespace-nowrap text-muted-foreground"
            >
              {@render wikiLink(
                key,
                osmWikiKeyHref(key),
                `Open OSM Wiki page for ${key}`,
              )}
            </td>
            <td class="border-b border-border px-1 py-1 align-top break-all">
              {#each valueParts(value) as part, index}
                {@const href = osmWikiTagHref(key, part.trim())}
                {#if index > 0};{/if}
                {#if href}
                  {@render wikiLink(
                    part,
                    href,
                    `Open OSM Wiki page for ${key}=${part.trim()}`,
                  )}
                {:else}
                  {part}
                {/if}
              {/each}
            </td>
          </tr>
        {/each}
      </tbody>
    </table>

    {#if osmHref}
      <a
        class="mt-3 inline-flex min-h-8 items-center gap-2 rounded-sm text-sm text-foreground no-underline hover:underline"
        href={osmHref}
        target="_blank"
        rel="noopener noreferrer"
      >
        <span class="min-w-0 truncate">OpenStreetMap direct link</span>
        <ExternalLink class="size-3 shrink-0 text-muted-foreground" />
      </a>
    {/if}
  </div>
</details>
